import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'bdg-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertComponent {
  @Input()
  type: 'danger' | 'warning' | 'info' | 'success'

  get icon() {
    if (this.type === 'danger') return 'error'
    if (this.type === 'success') return 'check_circle'
    if (this.type === 'info') return 'info'
    if (this.type === 'warning') return 'warning'
    return null
  }
}
